import { render, staticRenderFns } from "./TableSafe.vue?vue&type=template&id=e82dacbe&scoped=true"
import script from "./TableSafe.vue?vue&type=script&lang=js"
export * from "./TableSafe.vue?vue&type=script&lang=js"
import style0 from "./TableSafe.vue?vue&type=style&index=0&id=e82dacbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82dacbe",
  null
  
)

export default component.exports